import React, { useState } from 'react';
import SingleQA from './SingleQA';
import styles from './styles.module.css';
import { qaItem } from '@/commonTypes';

export default function QAcomponent({
  list,
  className = '',
  activeButtonStyle = '',
  singleQaClass = '',
}: {
  list?: qaItem[];
  className?: string;
  activeButtonStyle?: string;
  singleQaClass?: string;
}) {
  const [active, setActive] = useState<null | { id?: number | string }>();
  // const [list, setlist] = useState([
  //   {
  //     id: 1,
  //     question: 'یک پروژه‌ی AI معمولاً چقدر طول می‌کشد و چقدر هزینه دارد؟',
  //     answer:
  //       ' یک MVP کارا معمولاً بین ۶ تا ۱۰ هفته آماده می‌شود. هزینه به دامنه‌ی پروژه، حجم داده‌ها و سطح یکپارچه‌سازی با سامانه‌های داخلی شما بستگی دارد. در جلسه‌ی اول، یک محدوده‌ی شفاف ارائه می‌دهیم.',
  //   },
  //   {
  //     id: 2,
  //     question: ' داده‌های ما در فرآیند آموزش مدل‌ها به‌کار می‌رود؟',
  //     answer:
  //       'خیر. ما از APIهایی استفاده می‌کنیم که داده‌ی شما را برای آموزش به‌کار نمی‌برند، و برای پروژه‌های حساس گزینه‌ی استقرار On-prem روی زیرساخت خودتان هم در دسترس است.',
  //   },
  //   {
  //     id: 3,
  //     question: 'چه تضمینی برای کیفیت پاسخ‌های مدل می‌دهید؟',
  //     answer:
  //       'معیارهای کیفی پروژه را در فاز کشف با شما توافق می‌کنیم. سپس یک eval suite اختصاصی می‌سازیم که هر تغییر در پرامپت یا مدل را پیش از انتشار می‌سنجد. کیفیت در طول زمان پایش می‌شود، نه فقط در روز اول.',
  //   },
  //   {
  //     id: 4,
  //     question: 'چه مدل‌هایی استفاده می‌کنید؟ آیا به یک شرکت خاص وابسته‌ایم؟',
  //     answer:
  //       'از مدل‌های مختلف بسته به مسئله: GPT-4، Claude، Llama، Mistral. برای جلوگیری از قفل‌شدگی به یک ارائه‌دهنده، لایه‌ی انتزاع روی مدل می‌سازیم تا در صورت لزوم بتوانید مدل را عوض کنید.',
  //   },
  // ]);

  return (
    <div className={`${styles.qaContainer} ${className}`}>
      {list?.map((item, index) => (
        <SingleQA
          item={item}
          key={index}
          onClick={(item) => {
            if (active?.id == item?.id) {
              setActive(null);
            } else {
              setActive(item);
            }
          }}
          active={active}
          number={index + 1}
          activeButtonStyle={activeButtonStyle}
          singleQaClass={singleQaClass}
        />
      ))}
    </div>
  );
}
